import { GRANULARITY } from '../../../performance/views/CustomReport/consts';
import { getTrendLineDataMappedPerMericName } from '../../GroupDashboard/GroupMetricsWidget/GroupMetricsWidget.service';
import GroupMetricsWidgetNew from '../../GroupDashboard/GroupMetricsWidget/GroupMetricsWidgetNew';
import { StyledMetricWidget } from './MetricWidget.style';

const MetricWidget = ({
  isWidgetLoading = false,
  widgetMetricName,
  selectedTeamId,
  V3DataCalculated,
  formattedV3Data,
  metricsPerGranularityMapped,
  metricsWidgetData,
  metricsWidgetsByName
}) => {
  const trendLineData = getTrendLineDataMappedPerMericName(
    widgetMetricName,
    metricsPerGranularityMapped,
    metricsWidgetData
  );

  return (
    <StyledMetricWidget
      data-testid={`freePlusMetricWidget-${widgetMetricName}`}
    >
      <GroupMetricsWidgetNew
        isWidgetLoading={isWidgetLoading}
        widgetMetricName={widgetMetricName}
        widgetMetricValue={V3DataCalculated[widgetMetricName]}
        displayValueText={formattedV3Data[widgetMetricName]}
        selectedGroupId={selectedTeamId}
        isCustomizeMetrics={false}
        availableMetricsWidget={metricsWidgetsByName[widgetMetricName]}
        trendLineData={trendLineData}
        granularity={GRANULARITY.WEEKS}
      />
    </StyledMetricWidget>
  );
};

export default MetricWidget;
